import React, { useState, useEffect } from "react";
import CreateBill from "../../../../../entities/DashboardPage/AccountingModule/Supplier/CreateBill";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";

const CreateBillPage = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [supplierList, setSupplierList] = useState();
  const [loading, setLoading] = useState(false);
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    getItem();
    getSupplierList();
  }, []);

  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getItem = async (text) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getItemsList(text);

      if (result?.success) {
        setItemList(result?.data?.items);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const handleAddNewBill = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleBill(payload);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <CreateBill handleAddNewBill={handleAddNewBill} loading={loading} itemList={itemList} supplierList={supplierList} handleSupplierList={getSupplierList} />
  )

}

export default CreateBillPage;
